import React, { FC, useCallback, useMemo, useState } from 'react';
import { Link } from 'react-router';

import { Drawer } from '@mui/material';

import { useMediaQuery } from '@hooks/common/useMediaQuery';

import logo from '@assets/logos/logo.png';

import { IDs } from '@constants/common/ids.constants';

import HeaderContainer from './HeaderContainer';
import MobileMenu from './MobileMenu';
import HeaderButtons from './MobileMenu/HeaderButtons';
import useStyles from './styles.module';

const Header: FC = () => {
  const { classes } = useStyles();
  const { mobileView, isLaptop } = useMediaQuery();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleClose = useCallback(() => {
    setIsSidebarOpen(false);
  }, []);

  const handleOpen = useCallback(() => {
    setIsSidebarOpen(true);
  }, []);

  const isMobView = useMemo(
    () => mobileView || isLaptop,
    [isLaptop, mobileView],
  );

  return (
    <header className={classes.headerBox}>
      {isMobView ? (
        <>
          <div className={classes.headerMob}>
            <img src={logo} alt="" className={classes.mobileLogo} />
            <HeaderButtons
              onOpen={handleOpen}
              onClose={handleClose}
              isOpen={isSidebarOpen}
            />
          </div>
          <Drawer
            anchor="right"
            open={isSidebarOpen}
            onClose={handleClose}
            className={classes.wrapSideBar}
            id={IDs.HEADER_SIDEBAR_MENU}
          >
            <MobileMenu aria-label="close drawer" onClose={handleClose} />
          </Drawer>
        </>
      ) : (
        <HeaderContainer />
      )}
    </header>
  );
};

export default Header;
